import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetPortal,
  SheetOverlay,
} from '@design-system/Sheet';
import { Skeleton } from '@design-system/Skeleton';

interface TrackingSampleSkeletonProps {
  isOpen: boolean;
  onClose: () => void;
}
  
export const TrackingSampleSkeleton = ({ isOpen, onClose }: TrackingSampleSkeletonProps) => (
  <Sheet open={isOpen} onOpenChange={onClose} data-testid="trackingSampleSkeleton-modal">
    <SheetPortal>
      <SheetOverlay data-testid="trackingSampleSkeleton-overlay" />
      <SheetContent side="right" className="w-full pr-0 pl-4" variant="glass" data-testid="trackingSampleSkeleton-content">
        <SheetHeader data-testid="trackingSampleSkeleton-header">
          <div className="space-y-4" data-testid="trackingSampleSkeleton-content">
            <Skeleton className="h-8 w-48" data-testid="trackingSampleSkeleton-title" />
            <Skeleton className="h-4 w-32" data-testid="trackingSampleSkeleton-subtitle" />
            {[...Array(8)].map((_, i) => (
              <Skeleton key={i} className="h-16 w-full mt-4" data-testid={`trackingSampleSkeleton-step-${i}`} />
            ))}
          </div>
        </SheetHeader>
      </SheetContent>
    </SheetPortal>
  </Sheet>
);